import type {VoidFn} from './types'

export const voidFn: VoidFn = () => {}

export const emptyObject = {}
export const emptyArray: ReadonlyArray<unknown> = []
